// NPM Imports
import React, { Fragment } from "react";
import ReactHtmlParser from "react-html-parser";

// Internal Imports
import { DOC_CTA_OPTIONS } from "../../../../constants/asset";
import PlanUpgrade from "../../../PlanUpgrade";

function DocumentCtaSelection(props) {
  return (
    <Fragment>
      <section className="documentctaselection-header">
        <div className="documentctaselection-title">
          What do you want to do today?
        </div>
        <div className="documentctaselection-sub-title">
          Choose an option and create the document in the next step.
        </div>
      </section>
      <section className="documentctaselection-body">
        {DOC_CTA_OPTIONS.map(option => (
          <div
            data-test={option.title}
            className="documentctaselection-option-wrapper"
            onClick={() => props.toggleScreen(2, option)}
            onKeyPress={() => {}}
            tabIndex="0"
            role="button">
            <div className="documentctaselection-upgrade">
              {props.checkFreePlan && option.upgradeAvilable && (
                <PlanUpgrade showOnlyOnFreePlan />
              )}
            </div>
            <div className="documentctaselection-option-img-wrapper">
              {option.img && <img src={option.img} alt="doc-cta-option" />}
            </div>
            <div className="documentctaselection-option-title">
              {option.title}
            </div>
            <div className="documentctaselection-option-desc">
              {ReactHtmlParser(option.description)}
            </div>
          </div>
        ))}
      </section>
      {/* commented for now, may need it later */}
      {/* <section className="documentctaselection-footer">
        <span className="documentctaselection-footer-button">
          {`I'll just get started for now`}
        </span>
      </section> */}
    </Fragment>
  );
}

export default DocumentCtaSelection;
